import React from "react";
import { Form, Input, Radio, theme } from "antd";

import noPainSvg from "../../../../../../assets/images/scalesImages/noPain.svg";
import lightPainSvg from "../../../../../../assets/images/scalesImages/lightPain.svg";
import moderatePainSvg from "../../../../../../assets/images/scalesImages/moderatePain.svg";
import severePainSvg from "../../../../../../assets/images/scalesImages/severePain.svg";
import verySeverePainSvg from "../../../../../../assets/images/scalesImages/verySeverePain.svg";
import worstPainSvg from "../../../../../../assets/images/scalesImages/worstPain.svg";

const PainSelection = ({ form, onValuesChange }) => {
  const { token } = theme.useToken();
  const selectedValue = Form.useWatch("pain", form);

  const vasOptions = [
    { value: 0, label: "No Pain", image: noPainSvg },
    { value: 1, label: "Mild", image: lightPainSvg },
    { value: 2, label: "Mild", image: lightPainSvg },
    { value: 3, label: "Mild", image: lightPainSvg },
    { value: 4, label: "Moderate", image: moderatePainSvg },
    { value: 5, label: "Moderate", image: moderatePainSvg },
    { value: 6, label: "Severe", image: severePainSvg },
    { value: 7, label: "Severe", image: severePainSvg },
    { value: 8, label: "Very Severe", image: verySeverePainSvg },
    { value: 9, label: "Very Severe", image: verySeverePainSvg },
    { value: 10, label: "Worst Pain", image: worstPainSvg },
  ];

const handleRadioClick = (value) => {
  const currentValue = form.getFieldValue("pain");
  const newValue = currentValue === value ? null : value;

  const interpretation =
    newValue !== null ? vasOptions[newValue]?.label : "";

  form.setFieldsValue({
    pain: newValue,
    pain_interpretation: interpretation,
  });

  onValuesChange?.({
    pain: newValue,
    pain_interpretation: interpretation,
  });
};

  return (
    <div className="physio-scales">
      <Form.Item name="pain_interpretation" hidden>
        <Input />
      </Form.Item>

      <Form.Item name="pain">
        <Radio.Group
          value={selectedValue}
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {vasOptions.map((option) => {
            const isSelected = selectedValue === option.value;
            return (
              <div
                key={option.value}
                onClick={() => handleRadioClick(option.value)}
                style={{
                  height: "100px",
                  width: "80px",
                  padding: "4px",
                  margin: "4px",
                  border: `2px solid ${
                    isSelected ? token.colorPrimary : "rgba(0, 0, 0, 0.15)"
                  }`,
                  borderRadius: "10px",
                  background: isSelected
                    ? token.colorPrimary
                    : "#fff",
                  color: isSelected ? "#fff" : "#000",
                  boxShadow: isSelected
                    ? `0 0 6px ${token.colorPrimary}`
                    : "none",
                  transition: "all 0.2s ease-in-out",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  if (!isSelected)
                    e.currentTarget.style.border = `1px solid ${token.colorPrimary}`;
                }}
                onMouseLeave={(e) => {
                  if (!isSelected)
                    e.currentTarget.style.border = "1px solid rgba(0,0,0,0.15)";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {option.image && (
                    <img
                      src={option.image}
                      alt={option.label}
                      style={{
                        width: 50,
                        height: 50,
                        marginBottom: 6,
                        objectFit: "contain",
                      }}
                    />
                  )}
                  <div
                    style={{
                      fontSize: "10px",
                      lineHeight: "1.2",
                      fontWeight: isSelected ? 600 : 400,
                      color: isSelected ? "#fff" : "#000",
                    }}
                  >
                    {option.value}
                    <br />
                    {option.label}
                  </div>
                </div>
              </div>
            );
          })}
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default PainSelection;
